export var STATIST_ENDPOINTS = {
    test: atob('aHR0cHM6Ly9hcGktc3RhdGlzdC5kZXYtdGNzZ3JvdXAuaW8='),
    prod: 'https://api-statist.tinkoff.ru',
};
export var SDK_VERSION = '__SDK_VERSION_PLACEHOLDER__';
//# sourceMappingURL=environment.js.map